<section id="section-158-1139" class="ct-section">
  <div class="ct-section-inner-wrap">
    <div id="div_block-159-1139" class="ct-div-block">
      <div id="div_block-160-1139" class="ct-div-block">
        <div id="code_block-161-1139" class="ct-code-block dragscroll categories-block">
          <ul id="category_selector" class="category-selector">
            <li
              class="access-link-wrapper"
              [ngClass]="{ current: categorySelected === 'todas' }"
              (click)="selectCategory('todas')"
              value="0"
            >
              Todas
            </li>
            <li
              class="access-link-wrapper"
              *ngFor="let item of categories"
              [value]="item.ID"
              [ngClass]="{ current: categorySelected === item.slug }"
              (click)="selectCategory(item.slug)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
